// extracted by mini-css-extract-plugin
module.exports = {"card":"Load_card__3LHR8"};